import React from 'react';

import { Icon } from '../Icon';

import { IconDeciderProps } from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const IconDecider: React.FC<IconDeciderProps> = (props) => {
  const { icon, ...rest } = props;

  // =============== VARIABLES
  const isIconString = typeof icon === 'string';

  // =============== VIEWS
  if (isIconString) {
    return <Icon icon={icon} {...rest} />;
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{icon}</>;
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default IconDecider;
